import React, { useState, useRef } from 'react';
import './HeroVideo.css';
import { PauseIcon, PlayIcon, SoundOffIcon, SoundOnIcon } from './Icons';

const HeroVideo = () => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  const togglePlay = () => {
    const video = videoRef.current;
    if (video) {
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    const video = videoRef.current;
    if (video) {
      video.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <div className="media video hotel">
      <div className="media-wrapper">
        {/* Background blur image */}
        <div
          className="video-cover-image image-blur-wrapper"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1566073771259-6a8506099945?w=10&h=10&fit=crop)',
            aspectRatio: '1600 / 540'
          }}
        >
          <picture className="responsive-image">
            <img
              alt="Luxury Hotel Facade"
              width="1600"
              height="540"
              src="https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600&h=540&fit=crop&q=80"
              className="vue-responsive-image"
              style={{ aspectRatio: 'inherit' }}
            />
          </picture>
        </div>

        {/* Video player */}
        <div className="vimeo-root">
          <video
            ref={videoRef}
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          >
            <source src="/videos/jaipur.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Hero Content Overlay */}
        <div className="hero-content-overlay">
          <div className="hero-text-content">
            <h2>Welcome to The Jaipur Hotels</h2>
            <p>Your perfect base to explore the magnificent Pink City. We offer comfortable accommodation with a touch of Rajasthani heritage, modern amenities, and warm hospitality that makes you feel at home.</p>
            <a href="#contact" className="hero-cta-button">Book Your Stay Now</a>
          </div>
        </div>
      </div>

      {/* Video controls */}
      <div className="video-controls">
        <button
          aria-label={isPlaying ? "Pause video" : "Play video"}
          className="video-control-button"
          onClick={togglePlay}
        >
          {isPlaying ? <PauseIcon /> : <PlayIcon />}
        </button>
        <button
          aria-label={isMuted ? "Unmute video" : "Mute video"}
          className="video-control-button"
          onClick={toggleMute}
        >
          {isMuted ? <SoundOffIcon /> : <SoundOnIcon />}
        </button>
      </div>
    </div>
  );
};

export default HeroVideo;
